import AddIcon from "@mui/icons-material/Add";
import DescriptionIcon from "@mui/icons-material/Description";

// Maps the `createApplication.icon` config value (navigation.config.json) to
// the icon rendered on the "Create New Application" action in both the left nav
// (AccountCard) and the Applications header (PageHeader). Keeping a single map
// ensures both entry points stay in sync for a given market.
const createApplicationIconMap = {
  AddIcon,
  DescriptionIcon,
};

const getCreateApplicationIcon = (iconName) =>
  createApplicationIconMap[iconName] ?? AddIcon;

export default getCreateApplicationIcon;
